import React, { useState } from 'react';
import { InputCheckbox } from '../../../Inputs';
import TableRow from '../../TableRow/TableRow';

const CommercialRefinanceLenderPremiumBody = ({
  assessmentRecoupmentCharge,
  taxDeletion,
  notDuePayable,
  t19Result,
  t23LenderResult,
  t25LenderResult,
  t28LenderResult,
  t33LenderResult,
  t36LenderResult,
  t39LenderResult,
  escrowFee,
  estimatedRecordingFee,
  checkboxValues,
  handleInputChange,
  totals,
  ...props
}) => {
  // destructuring the totals
  const {
    totalAdjustedPremium,
    totalLenderPolicyAndEscrowFee,
    totalLenderPolicyPremium,
  } = totals;
  return (
    <tbody>
      <TableRow
        type="checkbox"
        label="Adjusted Premium"
        valueType="currency"
        value={totalAdjustedPremium}
      />
      <TableRow
        type="checkbox"
        label="Policy Guaranty Fee"
        valueType="currency"
        value={assessmentRecoupmentCharge}
      />
      <TableRow
        type="checkbox"
        label="Tax Deletion"
        valueType="currency"
        value={taxDeletion}
      />
      <TableRow
        type="checkbox"
        label="Not Yet Due and Payable"
        valueType="currency"
        value={notDuePayable}
      />
      <TableRow
        type="checkbox"
        label="T-19 (Rest/Encro/Mineral)"
        valueType="currency"
        value={t19Result}
      >
        <InputCheckbox
          values={checkboxValues}
          checked={checkboxValues.t_19_lender}
          handleInputChange={handleInputChange}
          id="t_19_lender"
          name="t_19_lender"
          className="u--margin-0"
        />
      </TableRow>
      <TableRow
        type="checkbox"
        label="T-23 (Access)"
        valueType="currency"
        value={t23LenderResult}
      >
        <InputCheckbox
          values={checkboxValues}
          checked={checkboxValues.t_23_lender}
          handleInputChange={handleInputChange}
          id="t_23_lender"
          name="t_23_lender"
          className="u--margin-0"
        />
      </TableRow>
      <TableRow
        type="checkbox"
        label="T-25 (Contiguity)"
        valueType="currency"
        value={t25LenderResult}
      >
        <InputCheckbox
          values={checkboxValues}
          checked={checkboxValues.t_25_lender}
          handleInputChange={handleInputChange}
          id="t_25_lender"
          name="t_25_lender"
          className="u--margin-0"
        />
      </TableRow>
      <TableRow
        type="checkbox"
        label="T-28 (Condo)"
        valueType="currency"
        value={t28LenderResult}
      >
        <InputCheckbox
          values={checkboxValues}
          checked={checkboxValues.t_28_lender}
          handleInputChange={handleInputChange}
          id="t_28_lender"
          name="t_28_lender"
          className="u--margin-0"
        />
      </TableRow>
      <TableRow
        type="checkbox"
        label="T-33 (ARM)"
        valueType="currency"
        value={t33LenderResult}
      >
        <InputCheckbox
          values={checkboxValues}
          checked={checkboxValues.t_33_lender}
          handleInputChange={handleInputChange}
          id="t_33_lender"
          name="t_33_lender"
          className="u--margin-0"
        />
      </TableRow>
      <TableRow
        type="checkbox"
        label="T-36 (EPA)"
        valueType="currency"
        value={t36LenderResult}
      >
        <InputCheckbox
          values={checkboxValues}
          checked={checkboxValues.t_36_lender}
          handleInputChange={handleInputChange}
          id="t_36_lender"
          name="t_36_lender"
          className="u--margin-0"
        />
      </TableRow>
      <TableRow
        type="checkbox"
        label="T-39 (Balloon)"
        valueType="currency"
        value={t39LenderResult}
      >
        <InputCheckbox
          values={checkboxValues}
          checked={checkboxValues.t_39_lender}
          handleInputChange={handleInputChange}
          id="t_39_lender"
          name="t_39_lender"
          className="u--margin-0"
        />
      </TableRow>
      <TableRow
        type="checkbox"
        className="tr--result"
        label="Total Lender Policy Premium"
        valueType="currency"
        value={totalLenderPolicyPremium}
      />
      <TableRow
        type="checkbox"
        className="tr--result"
        label="Escrow Fee"
        valueType="currency"
        value={escrowFee}
      />
      <TableRow
        type="checkbox"
        className="tr--result"
        label="Total Lender Policy & Escrow Fee"
        valueType="currency"
        value={totalLenderPolicyAndEscrowFee}
      />
      <TableRow
        type="checkbox"
        label="Estimated Recording Fees"
        subLabel="* Per document charge is $26 for the first page, $4 for each additional page $4.80 e–filing fee"
        valueType="currency"
        value={estimatedRecordingFee}
      />
    </tbody>
  );
};

export default CommercialRefinanceLenderPremiumBody;
